<template>
  <div id="app-div" style="overflow-y: hidden">
    <div class="top">
      <div class="search_icon">
        <span style="margin-left: 10px">
          <img src="../../../../assets/u3220.png" class="icon_img" />
          筛选查询
        </span>
      </div>
      <div class="query_div">
        <a-row>
          <a-col :span="5">
            <label>作者姓名：</label>
            <a-input placeholder="请输入" v-model="queryAuthorName" class="query_input" />
          </a-col>
          <a-col :span="5">
            <label style="margin-left: 15px">单位：</label>
            <a-input placeholder="请输入" v-model="queryCompanyName" class="query_input" />
          </a-col>
          <a-button type="primary" class="query_btn" @click="query"> 查询 </a-button>
          <!-- <a-button
            type="primary"
            style="float: right"
            @click="() => addMethod('add')"
          >
            新增
          </a-button> -->
        </a-row>
      </div>
    </div>
    <div class="middle">
      <div style="float: left; margin-left: 10px">
        <img src="../../../../assets/u3227.png" class="icon_img" />
        <span>&nbsp;数据列表</span>
      </div>
      <div style="float: right">
        排序方式：
        <a-select size="small" defaultValue="1" style="width: 120px" @change="sortChange" v-model="sort">
          <a-select-option value="1">编号降序</a-select-option>
          <a-select-option value="2">编号升序</a-select-option>
          <a-select-option value="3">时间降序</a-select-option>
          <a-select-option value="4">时间升序</a-select-option>
        </a-select>
      </div>
    </div>
    <div class="bottom" id="bottom">
      <div class="table_box">
        <a-table
          :pagination="false"
          :rowSelection="rowSelection"
          :columns="columns"
          :dataSource="data"
          :rowKey="record => record.authorCode"
          size="small"
          :scroll="{ y: data.length < 8 ? false : table_height }"
          bordered
        >
          <template slot="sort" slot-scope="text, record, index">
            {{ `${(page - 1) * limit + index + 1}` }}
          </template>
          <span slot="operator" slot-scope="text, record">
            <a href="javascript:void(0);" @click="() => checkMethod(record, 'check')"> 查看 </a>
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => editMethod(record, 'edit')"> 编辑 </a>
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => changeStatus(record, '1')"> 启用 </a>
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => changeStatus(record, '0')"> 禁用 </a>
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => deleteMethod(record)"> 删除 </a>
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => updatePwd(record)"> 重置密码 </a>
          </span>
          <span slot="status" slot-scope="text, record">
            <label v-if="record.status == '1'">
              <img class="status_img" src="../../../../assets/open.png" />已启用
            </label>
            <label v-if="record.status == '0'">
              <img class="status_img" src="../../../../assets/close.png" />已禁用
            </label>
          </span>
          <span slot="sex" slot-scope="text, record">
            <label v-if="record.sex == '1'">男</label>
            <label v-if="record.sex == '0'">女</label>
          </span>
        </a-table>
      </div>
      <div id="components-pagination-demo-mini">
        <a-pagination
          :total="total"
          :showTotal="total => `共 ${total} 条`"
          showSizeChanger
          showQuickJumper
          :pageSizeOptions="pageSizeOptions"
          :defaultPageSize="limit"
          @showSizeChange="onShowSizeChange"
          @change="pageChange"
        />
      </div>
      <a-select defaultValue="0" class="batch_operation" @change="operateChange" v-model="operateCode">
        <a-select-option value="0">批量操作</a-select-option>
        <a-select-option value="1">批量导出</a-select-option>
        <a-select-option value="2">批量禁用</a-select-option>
        <a-select-option value="3">批量启用</a-select-option>
      </a-select>
    </div>
    <a-modal :title="title" v-model="visible" width="600px" @cancel="cancel" @ok="enSure" :maskClosable="false">
      <template>
        <div>
          <a-row v-if="isShow">
            <a-col :span="6" class="title"> <span style="color: red">*</span>作者编号： </a-col>
            <a-col :span="12">
              <a-input placeholder="请输入" class="input" v-model="author.authorCode" v-bind:read-only="true" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title"> <span style="color: red">*</span>作者姓名： </a-col>
            <a-col :span="12">
              <a-input placeholder="请输入" class="input" v-model="author.authorName" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title"> 职称： </a-col>
            <a-col :span="12">
              <a-input placeholder="请输入" class="input" v-model="author.professionalTitle" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title"> 研究方向： </a-col>
            <a-col :span="12">
              <a-input placeholder="请输入" class="input" v-model="author.studyDirection" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title"> <span style="color: red">*</span>联系电话： </a-col>
            <a-col :span="12">
              <a-input placeholder="请输入" class="input" v-model="author.phone" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title"> <span style="color: red">*</span> E-mail： </a-col>
            <a-col :span="12">
              <a-input placeholder="请输入" class="input" v-model="author.email" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title"> <span style="color: red">*</span>单位名称： </a-col>
            <a-col :span="12">
              <a-input placeholder="请输入" class="input" v-model="author.companyName" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title"> <span style="color: red">*</span>单位地址： </a-col>
            <a-col :span="12">
              <a-input placeholder="请输入" class="input" v-model="author.companyAddress" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title"> <span style="color: red">*</span>性别： </a-col>
            <a-col :span="12">
              <a-radio-group v-model="value" @change="sexChange">
                <a-radio :value="1">男</a-radio>
                <a-radio :value="0">女</a-radio>
              </a-radio-group>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title"> <span style="color: red">*</span>出生年月： </a-col>
            <a-col :span="12">
              <a-month-picker :value="date" @change="dateChange" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title">状态：</a-col>
            <a-col :span="8" id="status_checkbox">
              <a-checkbox :checked="isChecked" @change="statusChange">启用</a-checkbox>
            </a-col>
          </a-row>
        </div>
      </template>
    </a-modal>

    <a-modal title="查看" v-model="checkVisible" width="600px" :footer="null" centered :maskClosable="false">
      <template>
        <div>
          <a-row v-if="isShow">
            <a-col :span="5" class="title"> 作者编号： </a-col>
            <a-col :span="6" style="margin-top: 5px">
              {{ author.authorCode }}
            </a-col>
            <a-col :span="5" class="title"> 作者姓名： </a-col>
            <a-col :span="6" style="margin-top: 5px">
              {{ author.authorName }}
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="5" class="title"> 联系电话： </a-col>
            <a-col :span="6" style="margin-top: 5px">
              {{ author.phone }}
            </a-col>
            <a-col :span="5" class="title"> E-mail： </a-col>
            <a-col :span="8" style="margin-top: 5px">
              {{ author.email }}
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="5" class="title"> 单位名称： </a-col>
            <a-col :span="12" style="margin-top: 5px">
              {{ author.companyName }}
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="5" class="title"> 单位地址： </a-col>
            <a-col :span="12" style="margin-top: 5px">
              {{ author.companyAddress }}
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="5" class="title">性别：</a-col>
            <a-col :span="6" style="margin-top: 5px">
              <label v-if="author.sex == 1">男</label>
              <label v-if="author.sex == 0">女</label>
            </a-col>
            <a-col :span="5" class="title">出生年月：</a-col>
            <a-col :span="6" style="margin-top: 5px">
              {{ author.birth }}
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="5" class="title">学历：</a-col>
            <a-col :span="6" style="margin-top: 5px">
              <label v-if="author.eduLevel == '1'">博士</label>
              <label v-if="author.eduLevel == '2'">硕士</label>
              <label v-if="author.eduLevel == '3'">本科</label>
              <label v-if="author.eduLevel == '4'">其他</label>
            </a-col>
            <a-col :span="5" class="title">状态：</a-col>
            <a-col :span="6" style="margin-top: 5px">
              <label v-if="author.status == 1">启用</label>
              <label v-if="author.status == 0">禁用</label>
            </a-col>
          </a-row>
        </div>
      </template>
    </a-modal>
    <a-modal title="提示" v-model="delVisible" @ok="deleteOk" :centered="true" width="300px" :maskClosable="false">
      <p>确认删除吗？</p>
    </a-modal>
    <a-modal
      title="密码重置"
      v-model="updatePwdVisible"
      @ok="updatePwdOk"
      :centered="true"
      width="300px"
      :maskClosable="false"
    >
      <p>您确定要为该用户进行密码重置？</p>
      <p>重置后密码将被设置为默认密码</p>
    </a-modal>
  </div>
</template>

<script>
import moment from "moment";
const columns = [
  {
    title: "序号",
    dataIndex: "sort",
    width: 60,
    scopedSlots: { customRender: "sort" },
  },
  {
    title: "作者编号",
    dataIndex: "authorCode",
    width: 130,
  },
  {
    title: "作者姓名",
    dataIndex: "authorName",
    width: 90,
  },
  {
    title: "单位名称",
    dataIndex: "companyName",
  },
  {
    title: "性别",
    width: 80,
    dataIndex: "sex",
    scopedSlots: { customRender: "sex" },
  },
  {
    title: "出生年月",
    width: 110,
    dataIndex: "birth",
  },
  {
    title: "状态",
    width: 90,
    dataIndex: "status",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "操作",
    width: 340,
    key: "operator",
    scopedSlots: { customRender: "operator" },
  },
];

const data = [];

import qs from "qs";
export default {
  name: "author",
  components: {
    // "check-role":checkRole
  },
  data() {
    return {
      serviceAddress: this.$config.serviceAddress,
      data,
      columns,
      selectedRowKeys: [],
      visible: false,
      checkVisible: false,
      author: {
        authorName: "",
        companyName: "",
        professionalTitle: "", //职称
        studyDirection: "", //研究方向
        sex: "1",
        status: "1",
        eduLevel: "0",
      },
      isChecked: true,
      date: null,
      oldPhone: "",
      isEnable: false,
      title: "查看",
      currentMode: "check",
      delVisible: false,
      updatePwdVisible: false,
      updatePwdUserName: "",
      queryAuthorName: "",
      queryCompanyName: "",
      sort: "1",
      sortField: "author_code",
      sortType: "desc",
      userType: 1,
      operateCode: "0",
      isShow: true,
      value: 1,
      page: 1,
      limit: 20,
      total: 0,
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      table_height: 0,
    };
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        columnWidth: 35,
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,
        onSelection: this.onSelection,
      };
    },
  },
  created() {
    this.query();
  },
  mounted() {
    //设置bottom高度
    var height = document.body.clientHeight;
    var bottom_height = height - 230;
    var bottom = document.getElementById("bottom");
    bottom.style.height = bottom_height + "px";
    this.table_height = bottom_height - 100;
  },
  methods: {
    moment,
    onShowSizeChange(current, pageSize) {
      this.page = current;
      this.limit = pageSize;
      this.query();
    },
    pageChange(pageNumber) {
      this.page = pageNumber;
      this.query();
    },
    sortChange() {
      if (this.sort == 1) {
        this.sortField = "author_code";
        this.sortType = "desc";
      } else if (this.sort == 2) {
        this.sortField = "author_code";
        this.sortType = "";
      } else if (this.sort == 3) {
        this.sortField = "create_time";
        this.sortType = "desc";
      } else if (this.sort == 4) {
        this.sortField = "create_time";
        this.sortType = "";
      }
      this.query();
    },
    operateChange() {
      var itemLegth = this.selectedRowKeys.length;
      if (itemLegth == 0) {
        this.utils.messageInfo(this, "error", "最少选择一条数据！");
        return;
      }
      if (this.operateCode == 1) {
        if (this.serviceAddress == "") {
          this.utils.messageInfo(this, "error", "获取后台ip地址失败，无法导出！");
          return;
        }
        var selectedRowKeys = this.selectedRowKeys;
        window.open(this.serviceAddress + "/author/exportData?codeArr=" + selectedRowKeys + "");
      } else if (this.operateCode == 2) {
        this.batchChangeStatus("0");
      } else if (this.operateCode == 3) {
        this.batchChangeStatus("1");
      }
    },
    batchChangeStatus(status) {
      var phones = [];
      for (var i = 0; i < this.data.length; i++) {
        for (var j = 0; j < this.selectedRowKeys.length; j++) {
          if (this.selectedRowKeys[j] == this.data[i].authorCode) {
            phones.push(this.data[i].phone);
          }
        }
      }
      this.axios
        .post("/author/changeAuthorStatus", {
          status: status,
          codes: JSON.stringify(this.selectedRowKeys),
          phones: JSON.stringify(phones),
        })
        .then(res => {
          if (res.data.code == "OK") {
            if (status == "0") {
              this.utils.messageInfo(this, "success", "禁用成功！");
            } else {
              this.utils.messageInfo(this, "success", "启用成功！");
            }

            this.query();
          } else {
            this.utils.messageInfo(this, "error", "操作失败！");
          }
        });
    },
    statusChange(e) {
      if (e.target.checked) {
        this.isChecked = true;
        this.author.status = 1;
      } else {
        this.isChecked = false;
        this.author.status = 0;
      }
    },
    query() {
      this.axios
        .get("/author/queryAuthor", {
          params: {
            authorName: this.queryAuthorName,
            companyName: this.queryCompanyName,
            sortField: this.sortField,
            sortType: this.sortType,
            page: this.page,
            limit: this.limit,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then(res => {
          if (res.data.code == "0") {
            this.total = res.data.count;
            this.data = res.data.data;
          } else {
            this.utils.messageInfo(this, "error", "查询作者列表失败！");
          }
        });
    },
    sexChange(e) {
      this.author.sex = e.target.value;
    },
    dateChange(date, dateString) {
      this.date = date;
      this.author.birth = dateString;
    },
    eduChange(value) {
      this.author.eduLevel = value;
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    addMethod(type) {
      this.author = {
        authorName: "",
        companyName: "",
        sex: "1",
        status: "1",
        eduLevel: "0",
      };
      this.isEnable = false;
      this.visible = true;
      this.isShow = false;
      this.title = "新增";
      this.currentMode = type;
    },
    checkMethod(obj) {
      this.author = obj;
      this.checkVisible = true;
      this.isShow = true;
    },
    editMethod(obj, type) {
      var birth = obj.birth;
      this.date = null;
      if (birth != undefined && birth != "") {
        this.date = moment(birth, "YYYY-MM");
      }
      if (obj.status == 1) {
        this.isChecked = true;
      } else {
        this.isChecked = false;
      }
      this.author = {
        authorCode: obj.authorCode,
        authorName: obj.authorName,
        phone: obj.phone,
        email: obj.email,
        birth: obj.birth,
        companyName: obj.companyName,
        companyAddress: obj.companyAddress,
        eduLevel: obj.eduLevel,
        professionalTitle: obj.professionalTitle,
        studyDirection: obj.studyDirection,
      };
      this.oldPhone = obj.phone;
      this.isEnable = false;
      this.visible = true;
      this.isShow = true;
      this.title = "编辑";
      this.currentMode = type;
    },
    changeStatus(obj, status) {
      var codes = [];
      var phones = [];
      codes.push(obj.authorCode);
      phones.push(obj.phone);
      this.axios
        .post("/author/changeAuthorStatus", {
          codes: JSON.stringify(codes),
          phones: JSON.stringify(phones),
          status: status,
        })
        .then(res => {
          if (res.data.code == "OK") {
            if (status == "0") {
              this.utils.messageInfo(this, "success", "禁用成功！");
            } else {
              this.utils.messageInfo(this, "success", "启用成功！");
            }
            for (var i = 0; i < this.data.length; i++) {
              if (this.data[i].authorCode == obj.authorCode) {
                this.data[i].status = status;
              }
            }
          } else {
            this.utils.messageInfo(this, "error", "编辑失败！");
          }
        });
    },
    deleteMethod(record) {
      this.delVisible = true;
      this.author = record;
    },
    deleteOk() {
      this.axios
        .post("/author/deleteAuthor", {
          authorCode: this.author.authorCode,
          phone: this.author.phone,
        })
        .then(res => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "删除成功");
            this.delVisible = false;
            this.query();
          } else {
            this.utils.messageInfo(this, "error", "删除失败！");
          }
        });
    },
    cancel() {
      this.visible = false;
    },
    enSure() {
      if (this.currentMode == "check") {
        this.visible = false;
      } else if (this.currentMode == "edit") {
        if (this.author.authorCode == "") {
          this.utils.messageInfo(this, "error", "作者编号不能为空！");
          return;
        } else if (this.author.authorName == "") {
          this.utils.messageInfo(this, "error", "作者姓名不能为空！");
          return;
        } else if (this.author.professionalTitle === undefined || this.author.professionalTitle === "") {
          this.utils.messageInfo(this, "error", "职称不能为空！");
          return;
        } else if (this.author.studyDirection === undefined || this.author.studyDirection === "") {
          this.utils.messageInfo(this, "error", "研究方向不能为空！");
          return;
        } else if (this.author.phone == "") {
          this.utils.messageInfo(this, "error", "联系电话不能为空！");
          return;
        } else if (this.author.email == "") {
          this.utils.messageInfo(this, "error", "E-mail不能为空！");
          return;
        } else if (this.author.companyName == "") {
          this.utils.messageInfo(this, "error", "单位名称不能为空！");
          return;
        } else if (this.author.companyAddress == "") {
          this.utils.messageInfo(this, "error", "单位地址不能为空！");
          return;
        } else if (this.author.birth === "" || this.author.birth === undefined) {
          this.utils.messageInfo(this, "error", "出生年月不能为空！");
          return;
        }
        if (!this.utils.isPhone(this.author.phone)) {
          this.utils.messageInfo(this, "error", "手机号格式不正确！");
          return;
        }
        if (!this.utils.isEmail(this.author.email)) {
          this.utils.messageInfo(this, "error", "邮箱格式不正确！");
          return;
        }
        this.axios
          .post("/author/updateAuthor", {
            authorCode: this.author.authorCode,
            authorName: this.author.authorName,
            phone: this.author.phone,
            email: this.author.email,
            companyName: this.author.companyName,
            companyAddress: this.author.companyAddress,
            sex: this.author.sex,
            birth: this.author.birth,
            eduLevel: this.author.eduLevel,
            status: this.author.status,
            professionalTitle: this.author.professionalTitle, //职称
            studyDirection: this.author.studyDirection, //研究方向
            oldPhone: this.oldPhone,
          })
          .then(res => {
            if (res.data.code == "OK") {
              this.utils.messageInfo(this, "success", "编辑成功");
              this.query();
              this.visible = false;
            } else {
              this.utils.messageInfo(this, "error", res.data.data);
            }
          });
      } else if (this.currentMode == "add") {
        if (this.author.authorName == "") {
          this.utils.messageInfo(this, "error", "作者姓名不能为空！");
          return;
        } else if (this.author.professionalTitle === undefined || this.author.professionalTitle === "") {
          this.utils.messageInfo(this, "error", "职称不能为空！");
          return;
        } else if (this.author.studyDirection === undefined || this.author.studyDirection === "") {
          this.utils.messageInfo(this, "error", "研究方向不能为空！");
          return;
        } else if (this.author.phone == "") {
          this.utils.messageInfo(this, "error", "联系电话不能为空！");
          return;
        } else if (this.author.email == "") {
          this.utils.messageInfo(this, "error", "E-mail不能为空！");
          return;
        } else if (this.author.companyName == "") {
          this.utils.messageInfo(this, "error", "单位名称不能为空！");
          return;
        } else if (this.author.companyAddress == "") {
          this.utils.messageInfo(this, "error", "单位地址不能为空！");
          return;
        } else if (this.author.birth === "" || this.author.birth === undefined) {
          this.utils.messageInfo(this, "error", "出生年月不能为空！");
          return;
        }
        if (!this.utils.isPhone(this.author.phone)) {
          this.utils.messageInfo(this, "error", "手机号格式不正确！");
          return;
        }
        if (!this.utils.isEmail(this.author.email)) {
          this.utils.messageInfo(this, "error", "邮箱格式不正确！");
          return;
        }
        this.axios
          .post("/author/saveAuthor", {
            authorName: this.author.authorName,
            phone: this.author.phone,
            email: this.author.email,
            companyName: this.author.companyName,
            companyAddress: this.author.companyAddress,
            sex: this.author.sex,
            birth: this.author.birth,
            eduLevel: this.author.eduLevel,
            status: this.author.status,
            professionalTitle: this.author.professionalTitle, //职称
            studyDirection: this.author.studyDirection, //研究方向
            creater: sessionStorage.getItem("userCode"),
          })
          .then(res => {
            if (res.data.code == "OK") {
              this.utils.messageInfo(this, "success", "添加成功");
              this.query();
              this.visible = false;
            } else {
              this.utils.messageInfo(this, "error", res.data.data);
            }
          });
      }
    },
    updatePwd(data) {
      this.updatePwdUserName = data.phone;
      this.updatePwdVisible = true;
    },
    updatePwdOk() {
      this.axios
        .post("/systemUser/updateDefaultPwd", {
          userName: this.updatePwdUserName,
          newPwd: "Bianji@123456",
        })
        .then(res => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "重置密码成功！");
            this.query();
          } else {
            this.utils.messageInfo(this, "error", res.data.data);
          }
        });
      this.updatePwdVisible = false;
    },
  },
};
</script>
<style>
@import "../../../../assets/css/PageCss.css";
</style>
<style scoped>
.title {
  text-align: right;
  line-height: 32px;
}
#status_checkbox {
  margin-top: 5px;
}
.status_img {
  width: 18px;
  margin-right: 6px;
  margin-bottom: 3px;
}
</style>
